import { Outlet, Navigate, Link as RouterLink } from 'react-router';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { Loader } from 'src/components/loader';

import { paths } from './paths';
import { useAdminAuth } from '../hooks/useAdminAuth';

// Gates the admin CMS. Unauthenticated (or non-admin, since /admin/user-info only
// answers admins) visitors go to /admin/login — never to SSO.
export function AdminProtectedRoute() {
  const { isLoading, isAuthenticated, isForbidden } = useAdminAuth();

  if (isLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Loader size={64} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    if (isForbidden) {
      return (
        <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
          <Paper
            variant="outlined"
            sx={{
              width: '100%',
              maxWidth: 420,
              p: 4,
              borderRadius: 2,
              borderColor: 'neutralLight.dark',
              textAlign: 'center',
            }}
          >
            <Stack spacing={2.5}>
              <Stack spacing={1}>
                <Typography component="h1" variant="h4">
                  Access denied
                </Typography>
                <Typography color="text.secondary" sx={{ fontSize: 16 }}>
                  Your account does not have admin access.
                </Typography>
              </Stack>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1.25}
                sx={{ justifyContent: 'center' }}
              >
                <Button component={RouterLink} to={paths.dashboard} variant="contained">
                  Go to dashboard
                </Button>
                <Button component={RouterLink} to={paths.admin.login} variant="outlined">
                  Admin sign in
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Box>
      );
    }

    return <Navigate to={paths.admin.login} replace />;
  }

  return <Outlet />;
}
